export var IntraCompanyQueryKey;
(function (IntraCompanyQueryKey) {
    IntraCompanyQueryKey["Overview"] = "IntraCompanyOverview";
    IntraCompanyQueryKey["Kpi"] = "IntraCompanyKpi";
    IntraCompanyQueryKey["Details"] = "IntraCompanyOverviewDetails";
})(IntraCompanyQueryKey || (IntraCompanyQueryKey = {}));
